import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedHeart = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="favourite" size="100%" color={stroke ?? color} />
);

export { LineRoundedHeart };
